<template>
  <div class="p-5">
    <!-- Loading State -->
    <LoadingIndicator v-if="loading" message="Loading data sources..." />

    <!-- Error State -->
    <div v-else-if="error" class="bg-red-50 border border-red-200 rounded-lg p-4">
      <p class="text-red-700">{{ error }}</p>
      <button @click="fetchData" class="mt-2 text-sm text-red-600 underline">Retry</button>
    </div>

    <!-- Data Loaded -->
    <template v-else-if="dataSources">
      <div class="mb-4">
        <PageHeader :heading-level="2" title="Data Integration Sources" :subtitle="dataSources.length + ' NCQA-required data types integrated'" />
      </div>

      <!-- Data Source Cards Grid -->
      <div class="grid grid-cols-2 gap-4">
        <div
          v-for="source in dataSources"
          :key="source.id"
          class="border border-gray-200 rounded-lg p-5 hover:shadow-md transition-shadow"
        >
          <!-- Card Header -->
          <div class="flex items-start justify-between mb-3">
            <div class="flex-1">
              <div class="flex items-center space-x-2">
                <div
                  class="w-2.5 h-2.5 rounded-full shrink-0"
                  :class="source.status === 'active' ? 'bg-green-500' : 'bg-gray-300'"
                ></div>
                <h3 class="text-sm font-semibold text-gray-900">{{ source.name }}</h3>
              </div>
              <span class="text-xs text-gray-400 ml-5">Factor {{ source.ncqa_factor }}</span>
            </div>
            <div class="text-right shrink-0">
              <div class="text-lg font-bold text-gray-900">{{ formatNumber(source.row_count) }}</div>
              <div class="text-xs text-gray-500">rows</div>
            </div>
          </div>

          <!-- Description -->
          <p class="text-xs text-gray-600 mb-3">{{ source.description }}</p>

          <!-- Source Systems -->
          <div class="flex flex-wrap gap-1.5">
            <span
              v-for="system in source.source_systems"
              :key="system"
              class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700"
            >
              {{ system }}
            </span>
          </div>

          <!-- Note (if present, e.g. HRA) -->
          <p v-if="source.note" class="text-xs text-amber-600 mt-3 italic">
            {{ source.note }}
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';

export default {
  name: 'PHM_DataIntegration',
  components: { LoadingIndicator, PageHeader },
  data() {
    return {
      loading: false,
      error: null,
      dataSources: null
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = null;
      try {
        const response = await this.$axios.get('/api/phm/data-sources/');
        this.dataSources = response.data.data_sources;
      } catch (err) {
        this.error = err.response?.data?.detail || 'Failed to load data sources';
      } finally {
        this.loading = false;
      }
    },
    formatNumber(num) {
      if (num == null) return '0';
      return Number(num).toLocaleString();
    }
  }
};
</script>

<style scoped>
</style>
